"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Any = exports.RawJson = exports.Reference = exports.Union = exports.Enum = exports.TxID = exports.Float = exports.BigInt = exports.Duration = exports.Time = exports.Url = exports.Bytes = exports.Hash = exports.String = exports.Bool = exports.Uint = exports.Int = void 0;
const _1 = require(".");
const buffer_1 = require("../common/buffer");
const encoding_1 = require("./encoding");
class Int {
    encode(value) {
        return (0, encoding_1.varintMarshalBinary)(value);
    }
}
exports.Int = Int;
class Uint {
    encode(value) {
        return (0, encoding_1.uvarintMarshalBinary)(value);
    }
}
exports.Uint = Uint;
class Bool {
    encode(value) {
        return (0, encoding_1.booleanMarshalBinary)(value);
    }
}
exports.Bool = Bool;
class String {
    encode(value) {
        return (0, encoding_1.stringMarshalBinary)(value);
    }
    raw(value) {
        return Bytes.raw(buffer_1.Buffer.from(value, "utf-8"));
    }
}
exports.String = String;
class Hash {
    encode(value) {
        return (0, encoding_1.hashMarshalBinary)(value);
    }
}
exports.Hash = Hash;
class Bytes {
    encode(value) {
        return (0, encoding_1.bytesMarshalBinary)(value);
    }
    raw(value) {
        return Bytes.raw(value);
    }
    static raw(value) {
        const length = (0, encoding_1.uvarintMarshalBinary)(value.length);
        return { length, value: buffer_1.Buffer.from(value) };
    }
}
exports.Bytes = Bytes;
class Url {
    encode(value) {
        return (0, encoding_1.stringMarshalBinary)(value.toString());
    }
    raw(value) {
        return Bytes.raw(buffer_1.Buffer.from(value.toString(), "utf-8"));
    }
}
exports.Url = Url;
class Time {
    encode(value) {
        return (0, encoding_1.uvarintMarshalBinary)(value.getTime() / 1000);
    }
}
exports.Time = Time;
class Duration {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    encode(_value) {
        throw new Error("TODO: marshal duration to binary");
    }
}
exports.Duration = Duration;
class BigInt {
    encode(value) {
        return (0, encoding_1.bigNumberMarshalBinary)(value);
    }
}
exports.BigInt = BigInt;
class Float {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    encode(_value) {
        throw new Error("TODO: marshal float to binary");
    }
}
exports.Float = Float;
class TxID {
    encode(value) {
        return (0, encoding_1.stringMarshalBinary)(value.toString());
    }
    raw(value) {
        return Bytes.raw(buffer_1.Buffer.from(value.toString(), "utf-8"));
    }
}
exports.TxID = TxID;
class Enum {
    constructor(type) {
        this.type = type;
    }
    encode(value) {
        return (0, encoding_1.uvarintMarshalBinary)(value);
    }
}
exports.Enum = Enum;
class Union {
    constructor() {
        this.composite = true;
    }
    encode(value) {
        return (0, encoding_1.bytesMarshalBinary)((0, _1.encode)(value));
    }
    consume(value, consumer) {
        (0, _1.consume)(value, consumer);
    }
}
exports.Union = Union;
class Reference {
    constructor() {
        this.composite = true;
    }
    encode(value) {
        return (0, encoding_1.bytesMarshalBinary)((0, _1.encode)(value));
    }
    consume(value, consumer) {
        (0, _1.consume)(value, consumer);
    }
}
exports.Reference = Reference;
class RawJson {
    encode(value) {
        const json = JSON.stringify(value);
        const bytes = buffer_1.Buffer.from(json, "utf-8");
        return (0, encoding_1.bytesMarshalBinary)(bytes);
    }
    raw(value) {
        const json = JSON.stringify(value);
        return Bytes.raw(buffer_1.Buffer.from(json, "utf-8"));
    }
}
exports.RawJson = RawJson;
class Any {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    encode(_value) {
        throw new Error("cannot marshal type any to binary");
    }
}
exports.Any = Any;
//# sourceMappingURL=encodable.js.map